import { motion } from 'framer-motion';
import { ModalFrame } from '../ui/modal';
import { IconClose } from '../ui/icons';
import { CATEGORIES, CATEGORY_COLORS } from './categories';

// Category filter, as a modal — same visual treatment as VaultAccessModal /
// VaultActivityLogModal, so Filter/Access Log/Manage Access read as one
// consistent set of action buttons rather than one being a plain popover.
export default function VaultCategoryFilterModal({ categoryCounts, activeCategory, onSelect, onClose }) {
  const total = Object.values(categoryCounts).reduce((sum, n) => sum + n, 0);

  function pick(key) {
    onSelect(key);
    onClose();
  }

  return (
    <ModalFrame onClose={onClose}>
      <motion.div
        role="dialog"
        initial={{ opacity: 0, y: 12, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 12, scale: 0.98 }} transition={{ duration: 0.18 }}
        style={{
          width: 'min(420px, calc(100vw - 48px))',
          maxHeight: 'calc(100vh - 96px)',
          background: '#fff',
          borderRadius: 16,
          boxShadow: '0 24px 60px rgba(15,20,25,0.22), 0 2px 6px rgba(15,20,25,0.08)',
          display: 'flex', flexDirection: 'column', overflow: 'hidden',
        }}
      >
        <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--border-subdued)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-emphasized)' }}>Filter by Category</div>
            <div style={{ fontSize: 12, color: 'var(--text-subdued)', marginTop: 2 }}>Jump straight to one category's section</div>
          </div>
          <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-subdued)', padding: 6, display: 'flex' }}>
            <IconClose size={16} />
          </button>
        </div>

        <div style={{ overflowY: 'auto', padding: 8 }}>
          <button type="button" onClick={() => pick(null)}
            style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%',
              padding: '9px 12px', fontSize: 13, fontWeight: !activeCategory ? 600 : 400,
              border: 'none', borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit',
              background: !activeCategory ? 'var(--color-primary-soft)' : 'transparent',
              color: !activeCategory ? 'var(--color-primary)' : 'var(--text-emphasized)',
            }}
            onMouseEnter={e => { if (activeCategory) e.currentTarget.style.background = 'var(--surface-default)'; }}
            onMouseLeave={e => { if (activeCategory) e.currentTarget.style.background = 'transparent'; }}>
            All Categories
            <span style={{ color: 'var(--text-subdued)', fontWeight: 400 }}>{total}</span>
          </button>
          {CATEGORIES.filter(c => categoryCounts[c.key]).map(c => {
            const active = activeCategory === c.key;
            return (
              <button key={c.key} type="button" onClick={() => pick(c.key)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 9, width: '100%',
                  padding: '9px 12px', fontSize: 13, fontWeight: active ? 600 : 400,
                  border: 'none', borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit',
                  background: active ? 'var(--color-primary-soft)' : 'transparent',
                  color: active ? 'var(--color-primary)' : 'var(--text-emphasized)',
                }}
                onMouseEnter={e => { if (!active) e.currentTarget.style.background = 'var(--surface-default)'; }}
                onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}>
                <span style={{ width: 8, height: 8, borderRadius: 999, background: CATEGORY_COLORS[c.key] || '#64748b', flexShrink: 0 }} />
                <span style={{ flex: 1, textAlign: 'left' }}>{c.label}</span>
                <span style={{ color: 'var(--text-subdued)', fontWeight: 400 }}>{categoryCounts[c.key]}</span>
              </button>
            );
          })}
        </div>
      </motion.div>
    </ModalFrame>
  );
}
